import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxIconRow',
  props: {
  icons: {
    required: true,
    type: Array as PropType<IconRowElement[]>,
    validator: function (iconRowElements: IconRowElement[]) {
      for (const iconRowElement of iconRowElements) {
        if (!Boolean(iconRowElement.name)) return false
      }
      return true
    },
  },

  column: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const iconContainerClass = computed(() => (props.column ? "column" : "row"))

const iconClass = computed(() => {
  return { "q-pt-xs": props.column }
})
//endregion

//region Functions
function getColor(icon: IconRowElement) {
  return icon.color ?? "transparent"
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(iconContainerClass.value)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.icons, (icon) => {
      return (_openBlock(), _createBlock(_component_q_icon, {
        class: _normalizeClass(["q-pr-xs", iconClass.value]),
        key: icon.name,
        name: icon.name,
        color: getColor(icon),
        size: "20px"
      }, null, 8, ["class", "name", "color"]))
    }), 128))
  ], 2))
}
}

})